import { NavLink } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { Home, Store, LayoutGrid, ShoppingBag, User } from "lucide-react";

const ITEMS = [
  { to: "/", label: "Home", icon: Home, end: true },
  { to: "/shop", label: "Shop", icon: Store },
  { to: "/categories", label: "Categories", icon: LayoutGrid },
  { to: "/cart", label: "Cart", icon: ShoppingBag, badge: "cart" },
  { to: "/account", label: "Account", icon: User },
];

export function MobileNav() {
  const { cartCount } = useApp();
  return (
    <nav data-testid="mobile-bottom-nav"
      className="lg:hidden fixed bottom-0 inset-x-0 z-50 bg-white border-t border-sage/30 shadow-[0_-4px_16px_rgba(0,0,0,0.06)] flex justify-around items-stretch h-16 pb-[env(safe-area-inset-bottom)]">
      {ITEMS.map((it) => (
        <NavLink key={it.to} to={it.to} end={it.end} data-testid={`mnav-${it.label.toLowerCase()}`}
          className={({ isActive }) => `relative flex-1 flex flex-col items-center justify-center gap-0.5 text-[11px] font-500 transition-colors ${isActive ? "text-orange" : "text-brown/60"}`}>
          <span className="relative">
            <it.icon className="w-5 h-5" strokeWidth={2} />
            {it.badge === "cart" && cartCount > 0 && (
              <span className="absolute -top-1.5 -right-2 bg-orange text-white text-[9px] font-700 min-w-[15px] h-[15px] px-1 rounded-full flex items-center justify-center">{cartCount}</span>
            )}
          </span>
          {it.label}
        </NavLink>
      ))}
    </nav>
  );
}
